import { logWarn, showErrorOnElement } from './errors.js';

const checkHorizontalScrollElements = document.querySelectorAll('[vdx-gsap-horizontalscroll]');

if (checkHorizontalScrollElements.length > 0){
    const firstEl = checkHorizontalScrollElements[0];
    if (typeof gsap === 'undefined') {
        logWarn('GSAP is missing. Please turn on GSAP in Webflow.', { module: 'GSAPHorizontalScroll' });
        showErrorOnElement(firstEl, 'GSAP is missing. Please turn on GSAP in Webflow.');
    }
    if (typeof ScrollTrigger === 'undefined') {
        logWarn('ScrollTrigger not found. Activate it in Webflow for animations.', { module: 'GSAPHorizontalScroll' });
        showErrorOnElement(firstEl, 'ScrollTrigger not found. Activate it in Webflow for animations.');
    }
}

if (checkHorizontalScrollElements.length > 0 && typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined'){
    gsap.registerPlugin(ScrollTrigger);
}

export const horizontalScroll = () => {
    if (checkHorizontalScrollElements.length > 0 && typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined'){
        const horizontalScrollElements = gsap.utils.toArray('[vdx-gsap-horizontalscroll]');
        if (horizontalScrollElements.length === 0) {
            return; 
        }
        horizontalScrollElements.forEach(container => {
            // Get animation type from the attribute
            const animationType = container.getAttribute('vdx-gsap-horizontalscroll');
            
            // Check if animation should be disabled (value is 'false')
            if (animationType === 'false') {
                // Skip animation for this container
                return;
            }
            
            if (container && container.children && container.children.length > 1) {
                gsap.to(Array.from(container.children), {
                    xPercent: -100 * (container.children.length - 1),
                scrollTrigger: {
                    trigger: container,
                    pin: true,
                    scrub: 3, // Increased from 1 to 3 to slow down the scrolling
                    end: "+=400", // Extend the scrolling distance to slow down the progression
                }
            });
        }
    
    });
    }
}